import React from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export const SidebarData = [
    {
        title :"Hello,Sign in" ,
        path : "/Signin",
        icon: <AccountCircleIcon />,
        cName:"nav-text2"
    },
{
    title :"MobilePhones" ,
    path : "/MobilePhones",
    cName:"nav-text"
},
{
    title :"Best Sellrs" ,
    path : "/MobilePhones",
    cName:"nav-text"
},
{
    title :"Movers & Shakers" ,
    path : "/MobilePhones",
    cName:"nav-text"
},
{
    title :"Contact Us" ,
    path : "/signup",
    cName:"nav-text"
},
{
    title :"Digital Content And Devices" ,
    path : "/MobilePhones",
    cName:"nav-text4"
},
{
    title :"Amazon Kindle E-readers",
    path : "/MobilePhones",
    cName:"nav-text"
},

{
    title :"Shop By Category" ,
    path : "/MobilePhones",
    cName:"nav-text4"
},
{
    title :"Mobiles, Tablets & Accessories" ,
    path : "/MobilePhones",
    cName:"nav-text"
},
{
    title :"Computers & Office Supplies" ,
    path : "/MobilePhones",
    cName:"nav-text"
},
{
    title :"TVs & Electronics" ,
    path : "/MobilePhones",
    cName:"nav-text"
},
{
    title :"Sign in" ,
    path : "/Signin",
    cName:"nav-text5"
}
]